import React from 'react';
import PropTypes from 'prop-types';

export function SvgTrash({ stroke = '#000000' }) {
  return (
    // <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    //   <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
    //     <path
    //       stroke={stroke}
    //       d="M4.667 5v7c0 .735.161.972.723.998L5.5 13h5c.613 0 .81-.194.831-.868l.002-.132V5H4.667zM7 6.5a.5.5 0 01.492.41L7.5 7v4a.5.5 0 01-.992.09L6.5 11V7a.5.5 0 01.5-.5zm2 0a.5.5 0 01.492.41L9.5 7v4a.5.5 0 01-.992.09L8.5 11V7a.5.5 0 01.5-.5zm.5-4.167h-3c-.35 0-.482.097-.498.562L6 3h4c0-.519-.109-.65-.428-.665L9.5 2.333zM13 12c0 1.818-.864 2.92-2.334 2.996L10.5 15h-5c-1.515 0-2.433-1.036-2.496-2.8L3 12V5H2V3h2c0-1.177.811-1.942 2.323-1.997L6.5 1h3c1.565 0 2.434.721 2.496 1.866L12 3h2v2h-1v7z"
    //     />
    //   </g>
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="feather feather-trash-2"
      viewBox="0 0 24 24"
    >
      <g>
        <path d="M3 6L5 6 21 6" />
        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
        <path d="M10 11L10 17" />
        <path d="M14 11L14 17" />
      </g>
    </svg>
  );
}

SvgTrash.propTypes = {
  stroke: PropTypes.string,
};
